import { useState, type FC } from "react";
import type { EmailDetailsModel } from "../../../models/EmailDetailsModel";
import TextLinkButton from "../../atoms/buttons/TextLinkButton";
import Modal from "../Modal";
import EmailDisplayModalContent from "../modals/EmailDisplayModalContent";
import { theme } from "../../../theme";
import { MailIconDainty } from "../../atoms/icons/MailIcon";
import { useTranslation } from "react-i18next";

interface Props {
  emailDetails: EmailDetailsModel;
}

const DisplayUploadUnitEmailDetailsButton: FC<Props> = ({ emailDetails }) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div>
      <TextLinkButton
        title={t("documentHandler.displayEmail")}
        onClick={() => setModalOpen(true)}
        color={theme.colors.primary}
        icon={<MailIconDainty color={theme.colors.primary} />}
      />
      {modalOpen && (
        <Modal onClose={() => setModalOpen(false)} closeIcon>
          <EmailDisplayModalContent emailContent={emailDetails} />
        </Modal>
      )}
    </div>
  );
};

export default DisplayUploadUnitEmailDetailsButton;
